// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3Dk-L","left":"classes_left__TRyit","logo":"classes_logo__3elD5","right":"classes_right__2T98B"};